const inactive = new Set(['cancelled', 'canceled', 'rejected', 'deleted']);
const count = value => {
  if (value == null || value === '' || typeof value === 'boolean') return null;
  const number = Number(value);
  return Number.isInteger(number) && number >= 0 ? number : null;
};

// Extra-service rows are authoritative, including cancellations. Legacy fields
// are mirrored values, not additional seats; never add them to service totals.
export function getOrderSeatRequirements(order = {}) {
  const extras = Array.isArray(order.extra_services) ? order.extra_services : [];
  return [
    ['child_seat', ['child_seat_count', 'child_seat_3_8_count']],
    ['infant_seat', ['infant_seat_count', 'infant_seat_0_3_count']],
  ].flatMap(([type, fields]) => {
    const rows = extras.filter(row => (typeof row === 'string' ? row : row?.service_type) === type);
    const legacy = fields.map(field => count(order[field])).filter(value => value > 0);
    if (rows.length) {
      const active = rows.filter(row => !inactive.has(String(row?.status || '').toLowerCase()));
      if (!active.length) return [];
      const quantities = active.map(row => count(row?.quantity));
      const total = quantities.reduce((sum, value) => sum + (value || 0), 0);
      const uncertain = quantities.some(value => !value) || legacy.some(value => value !== total);
      return [{ type, quantity: uncertain ? null : total }];
    }
    const requested = order[type] === true || order[type] === 1 || order[type] === 'true';
    if (!legacy.length && !requested) return [];
    return [{ type, quantity: legacy.length && new Set(legacy).size === 1 ? legacy[0] : null }];
  });
}
